import * as React from "react";
import * as Rest from "../../Generated/RestClient";
import {ChannelDataHandlers} from "./BotChannels";
import * as BotPage from "./BotPage";

export enum MenuCommands { Unsubmit, ViewInBotDirectory, Unpublish, RejectionDetails, Resubmit }

export interface BotSettingsTabProps extends React.Props<any> {
    bot: Rest.BotService;
    subscriptionKeys: BotPage.SubscriptionsKeys;
    channelDataHandlers: ChannelDataHandlers;
    isAdmin: () => boolean;
    isReviewer: () => boolean;
    isSubmitForReviewFlighted: boolean;
    isUserV3Flighted: boolean;
    configuredChannels: Rest.Channel[];
    iconFile?: BotPage.IconFile;
    reviewStatusDetail: Rest.ReviewStatusDetail;
}



// WEBPACK FOOTER //
// ./Client/v4/Views/BotSettingsTab.tsx